import React, { useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader, InfoWindow } from '@react-google-maps/api';
import { useEffect } from "react";

import './Map.css'
import './Card.css';

import ButtonComprar from '../../../src/components/buttons/ButtonComprar';
import ButtonMapa from '../../../src/components/buttons/ButtonMapa';

import logoWalmart from '../../assets/imgs/walmart.jpg';
import logoWalmartExpress from '../../assets/imgs/walmart-express.jpg'
import logoSoriana from '../../assets/imgs/soriana.jpg';
import logoAlsuper from "../../assets/imgs/alsuper.jpg";
import logoBodegaAurrera from "../../assets/imgs/bodega.jpg";
import logoChedraui from "../../assets/imgs/chedraui.jpg";
import logoHeb from "../../assets/imgs/heb.jpg";
import logoLacomer from "../../assets/imgs/lacomer.jpg";
import logoCalimax from "../../assets/imgs/calimax.jpg";
import logoOxxo from "../../assets/imgs/oxxo.jpg";


export default function Map() {
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(function(position) {
            setCenter({lat: position.coords.latitude, lng: position.coords.longitude});       
            updateBrand('Supercenter');
           
        });
    }, []);

    const [center, setCenter] = useState({lat: 19.432608, lng: -99.133209})
    const [jsonLoaded, setJsonLoaded] = useState(false);
    const [markersApi, setMarkersApi] = useState({});
    const [brand, setBrand] = useState('');
    
    let searchQ=window.location.search;
    let product= searchQ.replace("?path=/","")
    
    async function fetchJSON(url) {
        const response = await fetch(url);
        const markers = await response.json();
        /* console.log(markers); */
        return markers;
    }
    function updateBrand(brand) { 
        let analyticsParams={hitType: 'event',eventCategory: 'click',eventAction: 'Mapa - Ver - '+brand,eventLabel: product}
        let gtagParams={product: brand+' - '+product}

        //window["ga"]("send",analyticsParams);
        window["gtag"]('event','Clic Mapa Ver',gtagParams);
        setJsonLoaded(false);
        let url="https://bafar.com/api/data.php?query="+brand+"&location="+center.lat+"%2C"+center.lng;
        //let url="http://desarrollo.centralmedia.com.mx/bafar/data.php?query="+brand+"&location="+center.lat+"%2C"+center.lng;
            fetchJSON(url).then(json => {
                setMarkersApi(json);
                setJsonLoaded(true);
        });
        setBrand(brand)
    }
    function comprarBrand(brand) {         
        let analyticsParams={hitType: 'event',eventCategory: 'click',eventAction: 'Mapa - Comprar - '+brand,eventLabel: product}
        let gtagParams={product: brand+' - '+product}
        //window["ga"]("send",analyticsParams);
        window["gtag"]('event','Clic Mapa Comprar',gtagParams);

    }


    const {isLoaded} = useJsApiLoader({
        //googleMapsApiKey: "AIzaSyDc6daoUWkjfA8GofqZeLv11iNQfxGFRlE",
        googleMapsApiKey: "AIzaSyC-mkTGsLEGx2BQmWmetdF3mv0sJdyHzn4",
    })

    const [activeMarker, setActiveMarker] = useState(null);
    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
          return;
        }
        setActiveMarker(marker);
      };
    if (!isLoaded) { return <div>Cargando..</div> }
    /* if (!jsonLoaded) { return <div>Cargando...</div> } */

    let arrayMarkersApi = []
    Object.entries(markersApi).forEach(([key, value]) => {
        Object.entries(value.results).forEach(([key, value]) => {
            let repeated  = arrayMarkersApi.some(function(e) {
                return e.place_id===value.place_id;
            });  
            if(!repeated){
                arrayMarkersApi.push(value);
            }
        });
    });

    return(

    <div className='row pt-4 pb-4'>
        <div className='col-12 col-sm-12 col-md-12 col-lg-6'>
            <section className='box-scroll'>
                <div className={'card-shop' + (brand === 'Supercenter' ? ' brand-active' : '')}>
                    <img src={logoWalmart} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"supercenter"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://despensa.bodegaaurrera.com.mx/content/catalogo-por-marca/bafar/7338786_9397398?ad_source=onsite_display&ad_medium=gam&ad_brand=Bafar&ad_campaign_id=00004760" target="_blank" rel="noopener noreferrer" className='btn-ancla' ><ButtonComprar /></a>
                        <div id={"mapa_"+"supercenter"} onClick={updateBrand.bind(this,"Supercenter")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Walmart+Express' ? ' brand-active' : '')}>
                    <img src={logoWalmartExpress} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"walmartexpress"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://despensa.bodegaaurrera.com.mx/content/catalogo-por-marca/bafar/7338786_9397398?ad_source=onsite_display&ad_medium=gam&ad_brand=Bafar&ad_campaign_id=00004760" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"walmartexpress"} onClick={updateBrand.bind(this,"Walmart+Express")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Bodega+Aurrera' ? ' brand-active' : '')}>
                    <img src={logoBodegaAurrera} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"bodegaaurrera"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://despensa.bodegaaurrera.com.mx/content/catalogo-por-marca/bafar/7338786_9397398?ad_source=onsite_display&ad_medium=gam&ad_brand=Bafar&ad_campaign_id=00004760" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"bodegaaurrera"} onClick={updateBrand.bind(this,"Bodega+Aurrera")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Soriana' ? ' brand-active' : '')}>
                    <img src={logoSoriana} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"soriana"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.soriana.com/buscar?q=bafar&cid=&search-button=" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"soriana"} onClick={updateBrand.bind(this,"Soriana")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'La+Comer' ? ' brand-active' : '')}>
                    <img src={logoLacomer} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"lacomer"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.lacomer.com.mx/lacomer/?gclid=website#!/item-search/287/bafar/false?p=1&t=0&succId=287&succFmt=100" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"lacomer"} onClick={updateBrand.bind(this,"La+Comer")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Chedraui' ? ' brand-active' : '')}>
                    <img src={logoChedraui} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"chedraui"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.chedraui.com.mx/bafar?_q=bafar&map=ft" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"chedraui"} onClick={updateBrand.bind(this,"Chedraui")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'HEB' ? ' brand-active' : '')}>
                    <img src={logoHeb} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"heb"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.heb.com.mx/bafar?_q=bafar&map=ft" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"heb"} onClick={updateBrand.bind(this,"HEB")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Al+Super' ? ' brand-active' : '')}>
                    <img src={logoAlsuper} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"alsuper"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.alsuper.com/filtros?keyword=bafar" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"alsuper"} onClick={updateBrand.bind(this,"Al+Super")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'Calimax' ? ' brand-active' : '')}>
                    <img src={logoCalimax} alt="" className='logo-tienda'/>
                    <div>
                        <a id={"comprar_"+"calimax"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://tienda.calimax.com.mx/bafar?_q=bafar&map=ft" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        <div id={"mapa_"+"calimax"} onClick={updateBrand.bind(this,"Calimax")}><ButtonMapa /></div>
                    </div>
                </div>
                <div className={'card-shop' + (brand === 'OXXO' ? ' brand-active' : '')}>
                    <img src={logoOxxo} alt="" className='logo-tienda'/>
                    <div>
                        {
                            //<a id={"comprar_"+"oxxo"} onClick={comprarBrand.bind(this,"Supercenter")} href="https://www.oxxo.com/" target="_blank" rel="noopener noreferrer"><ButtonComprar /></a>
                        }
                        <div id={"mapa_"+"oxxo"} onClick={updateBrand.bind(this,"OXXO")}><ButtonMapa /></div>
                    </div>
                </div>
            </section>
        </div>

        <div className='col-12 col-sm-12 col-md-12 col-lg-6'>
            <GoogleMap
                    zoom={14}
                    center={center}
                    mapContainerStyle={{
                        width: '100%',
                        height: '500px'
                    }}
                >
                    <Marker
                            key="user"
                            position={center}
                        ></Marker>   
                    {arrayMarkersApi.map(({ place_id, name, geometry, formatted_address, opening_hours}) => (
                        <Marker
                            icon="//bafar.com/wp-content/uploads/2022/05/bafar.png"
                            key={place_id}
                            position={geometry.location}
                            id={"mapa_"+""} onClick={() => {setActiveMarker(null);handleActiveMarker(place_id);}}
                        >
                            {activeMarker === place_id ? (
                                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                <div className='div-info-window'>
                                    <h3 className='title-info-window'>{name}</h3>
                                    <p>{formatted_address}</p>
                                </div>
                                </InfoWindow>
                            ) : null}
                        </Marker>
                    ))}  
                    
            </GoogleMap>
            {/* <p>Tiendas : {brand}</p> */}
        </div>
        
    </div>
            
    )
}
